module.exports = __webpack_public_path__ + "static/media/notification.c17cc105.mp3";